import React, { Component } from 'react'
import { sectionData as sectionDataFunc } from '../Constants/InfoScreenText'
import { infoScreenAriaLabel } from '../Constants/AriaLabelText'
import $ from 'jquery'
import { injectIntl, FormattedMessage } from 'react-intl'


class InfoLanguage extends Component {
  handleTab(id, tabId) {
    $('.as-info-modal-wrapper')
      .find('li')
      .removeClass('active')
      .attr('aria-selected', false)
    $('.as-info-modal-wrapper').find('div').removeClass('show active')
    $(tabId).addClass('active').attr('aria-selected', true)
    $(id).addClass('show active')
  }

  render() {
    const { currentSection, isUKEnable = false, intl } = this.props
    let sectionData = sectionDataFunc(isUKEnable)
    return (
      <div>
        <div className="as-info-modal-wrapper">
          <div className="as-info-modal-close">
            <a
              href="javascript:void(0);"
              aria-label={infoScreenAriaLabel(intl)['close']}
              onClick={() => this.props.hideModal()}
              className="icon-cross as-profile-edit-close-btn modal-close-button"
            />
          </div>
          <div className="as-info-modal-heading">
            <FormattedMessage id="infoLanguage.heading.language" defaultMessage="Language" />
          </div>
          <div className="as-info-modal-subheading">
            <FormattedMessage id="infoLanguage.subheading.languageRole" defaultMessage="What is the role of language in LinkedIn profile?" />
          </div>
          <div className="as-info-modal-desc">
            <FormattedMessage id="infoLanguage.desc.languageImportance" defaultMessage="Your language plays a huge role in guiding the recruiter’s decision to continue reading your profile or not. Make sure that you avoid basic grammatical mistakes, write in consistent tense and avoid overuse of words." />
          </div>
          <div className="as-info-modal-nav">
            <div className="as-info-modal-nav-div">
              <div>
                <ul 
                  className="nav nav-tabs as-info-modal-nav-tabs" 
                  role="tablist"
                  tabIndex={0}
                  style={{ display: 'flex' }}
                >
                  <li
                    role="presentation"
                    className="active"
                    id="avoidedwordsTab">
                    <a
                      role="tab"
                      aria-selected={true}
                      aria-label={intl.formatMessage({ id: "infoLanguage.aria.actionOrientedSentence", defaultMessage: "what are action Oriented sentence?" })}
                      aria-controls="avoidedwords"
                      onClick={this.handleTab.bind(
                        this,
                        '#avoidedwords',
                        '#avoidedwordsTab'
                      )}
                      data-bs-toggle="tab">
                      <FormattedMessage id="infoLanguage.tab.avoidedWords" defaultMessage="Avoided Words" />
                    </a>
                  </li>
                  <li role="presentation" id="verboverusageTab">
                    <a
                      role="tab"
                      aria-selected={false}
                      aria-label={intl.formatMessage({ id: "infoLanguage.aria.verbOverusageSample", defaultMessage: "check verb Overusage Sample" })}
                      aria-controls="verboverusage"
                      onClick={this.handleTab.bind(
                        this,
                        '#verboverusage',
                        '#verboverusageTab'
                      )}
                      data-bs-toggle="tab">
                      <FormattedMessage id="infoLanguage.tab.verbOverusage" defaultMessage="Verb Overusage" />
                    </a>
                  </li>
                  <li role="presentation" id="voiceTab">
                    <a
                      role="tab"
                      aria-selected={false}
                      aria-label={intl.formatMessage({ id: "infoLanguage.aria.voiceConsistencySample", defaultMessage: "check voice Consistency Sample" })}
                      aria-controls="voice"
                      onClick={this.handleTab.bind(
                        this,
                        '#voice',
                        '#voiceTab '
                      )}
                      data-bs-toggle="tab">
                      <FormattedMessage id="infoLanguage.tab.voiceConsistency" defaultMessage="Voice Consistency" />
                    </a>
                  </li>
                  <li role="presentation" id="tenseconsistencyTab">
                    <a
                      role="tab"
                      aria-selected={false}
                      aria-label={intl.formatMessage({ id: "infoLanguage.aria.tenseConsistencySample", defaultMessage: "check tense consistency Sample" })}
                      aria-controls="tenseconsistency"
                      onClick={this.handleTab.bind(
                        this,
                        '#tenseconsistency',
                        '#tenseconsistencyTab'
                      )}
                      data-bs-toggle="tab">
                      <FormattedMessage id="infoLanguage.tab.tenseConsistency" defaultMessage="Tense Consistency" />
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div
                    role="tabpanel"
                    className="tab-pane fade show active"
                    id="avoidedwords">
                    <div className="as-info-modal-nav-content">
                      <div 
                        className="as-info-modal-nav-content-desc"
                      >
                        {sectionData['avoidedwords'][currentSection]['text']}
                      </div>
                      <h3
                        className="smp-heading"
                        tabIndex={0}
                        aria-label={intl.formatMessage({ id: "infoLanguage.heading.sampleBullets", defaultMessage: "Sample Bullets" })}
                      >
                        {' '}
                        <FormattedMessage id="infoLanguage.heading.sampleBullets" defaultMessage="Sample Bullets" />
                      </h3>
                      <div className="row as-info-modal-nav-content-row">
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-green">
                              <i className="fa fa-thumbs-up" aria-hidden="true" />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                role="heading"
                                tabIndex={0}
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['correct']
                                }
                              >
                                <FormattedMessage id="infoLanguage.heading.correctWay" defaultMessage="Correct way" />
                              </div>
                              {
                                sectionData['avoidedwords'][currentSection][
                                  'correct'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-red">
                              <i
                                className="fa fa-thumbs-down"
                                aria-hidden="true"
                              />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                role="heading"
                                tabIndex={0}
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['incorrect']
                                }
                              >
                                <FormattedMessage id="infoLanguage.heading.incorrectWay" defaultMessage="Incorrect way" />
                              </div>
                              {
                                sectionData['avoidedwords'][currentSection][
                                  'incorrect'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className="tab-pane fade"
                    id="verboverusage">
                    <div className="as-info-modal-nav-content">
                      <div 
                        className="as-info-modal-nav-content-desc"
                      >
                        {sectionData['verboverusage'][currentSection]['text']}
                      </div>
                      <h3
                        className="smp-heading"
                        tabIndex={0}
                        aria-label={intl.formatMessage({ id: "infoLanguage.heading.sampleBullets", defaultMessage: "Sample Bullets" })}
                      >
                        {' '}
                        <FormattedMessage id="infoLanguage.heading.sampleBullets" defaultMessage="Sample Bullets" />
                      </h3>
                      <div className="row as-info-modal-nav-content-row">
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-green">
                              <i className="fa fa-thumbs-up" aria-hidden="true" />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                role="heading"
                                tabIndex={0}
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['correct']
                                }
                              >
                                <FormattedMessage id="infoLanguage.heading.correctWay" defaultMessage="Correct way" />
                              </div>
                              {
                                sectionData['verboverusage'][currentSection][
                                  'correct'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-red">
                              <i
                                className="fa fa-thumbs-down"
                                aria-hidden="true"
                              />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['incorrect']
                                }
                              >
                                <FormattedMessage id="infoLanguage.heading.incorrectWay" defaultMessage="Incorrect way" />
                              </div>
                              {
                                sectionData['verboverusage'][currentSection][
                                  'incorrect'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className="tab-pane fade"
                    id="voice">
                    <div className="as-info-modal-nav-content">
                      <div 
                        className="as-info-modal-nav-content-desc"
                      >
                        {sectionData['voice'][currentSection]['text']}
                      </div>
                      <h3
                        className="smp-heading"
                        tabIndex={0}
                        aria-label={intl.formatMessage({ id: "infoLanguage.heading.sampleBullets", defaultMessage: "Sample Bullets" })}
                      >
                        <FormattedMessage id="infoLanguage.heading.sampleBullets" defaultMessage="Sample Bullets" />
                      </h3>
                      <div className="row as-info-modal-nav-content-row">
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-green">
                              <i className="fa fa-thumbs-up" aria-hidden="true" />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['correct']
                                }
                              >
                                <FormattedMessage id="infoLanguage.heading.correctWay" defaultMessage="Correct way" />
                              </div>
                              {
                                sectionData['voice'][currentSection][
                                  'correct'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-red">
                              <i
                                className="fa fa-thumbs-down"
                                aria-hidden="true"
                              />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['incorrect']
                                }
                              >
                                <FormattedMessage id="infoLanguage.heading.incorrectWay" defaultMessage="Incorrect way" />
                              </div>
                              {
                                sectionData['voice'][currentSection][
                                  'incorrect'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className="tab-pane fade"
                    id="tenseconsistency">
                    <div className="as-info-modal-nav-content">
                      <div 
                        className="as-info-modal-nav-content-desc"
                      >
                        {sectionData['tenseconsistency'][currentSection]['text']}
                      </div>
                      <h3
                        className="smp-heading"
                        tabIndex={0}
                        aria-label={intl.formatMessage({ id: "infoLanguage.heading.sampleBullets", defaultMessage: "Sample Bullets" })}
                      >
                        {' '}
                        <FormattedMessage id="infoLanguage.heading.sampleBullets" defaultMessage="Sample Bullets" />
                      </h3>
                      <div className="row as-info-modal-nav-content-row">
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-green">
                              <i className="fa fa-thumbs-up" aria-hidden="true" />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['correct']
                                }
                              >
                                <FormattedMessage id="infoLanguage.heading.correctWay" defaultMessage="Correct way" />
                              </div>
                              {
                                sectionData['tenseconsistency'][currentSection][
                                  'correct'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-red">
                              <i
                                className="fa fa-thumbs-down"
                                aria-hidden="true"
                              />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['incorrect']
                                }
                              >
                                <FormattedMessage id="infoLanguage.heading.incorrectWay" defaultMessage="Incorrect way" />
                              </div>
                              {
                                sectionData['tenseconsistency'][currentSection][
                                  'incorrect'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(InfoLanguage)
